import { render, staticRenderFns } from "./ReachDial.vue?vue&type=template&id=2dd042ad&"
import script from "./ReachDial.vue?vue&type=script&lang=js&"
export * from "./ReachDial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports